import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import Dialog from "sap/m/Dialog";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Article } from "vamos/cockpit/model/odata/VamosModel";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";
import { Input$LiveChangeEvent } from "sap/m/Input";
import ErrorService from "vamos/cockpit/base/services/type/ErrorService";


export default class NewArticleDialogController extends BaseTypeController {
    private dialog: Dialog;
    private _oDialogModel: JSONModel;


    private saveCallBack: (article: Article) => void;

    onInit(): void {
        super.onInit();
        this.dialog = this.getView().byId("newArticleDialog") as Dialog;
    }

    public openDialog(saveMultipleArticle: boolean, saveCallBack: (article: Article) => void): void {
        this.saveCallBack = saveCallBack;
        this._oDialogModel = new JSONModel({
            article: null,
            saveMultipleArticle: saveMultipleArticle,
        });
        this.initializeNewArticle();
        this.getView().setModel(this._oDialogModel, "articleDialog");
        this.dialog.open();
    }

    private initializeNewArticle() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const article: Article = {
            Number: null,
            Name: null,
            MaterialGroupGuid: null,
            MaterialGroupName: null,
            Description: null,
        };

        this._oDialogModel.setProperty("/article", article);
    }

    public async onSave() {
        const saved = await this.saveNewArticle();
        if (saved) {
            this.onCloseDialog();
        }
    }

    public async saveNewArticle(): Promise<boolean> {

        if (ValidationUtil.hasEmptyRequiredFields(this.dialog)) return false;

        const apiResponse = await ApiService.getInstance().postRestJsonDataWithoutMessage("/odata.svc/Articles", this._oDialogModel.getProperty("/article"));
        if (apiResponse.success) {
            const article = apiResponse.data as Article;
            this.saveCallBack(article);
        } else {
            await ErrorService.getInstance().showResponseErrors(apiResponse.data);
            return false;
        }
        return true;
    }

    public async onSaveAndNew() {
        const saved = await this.saveNewArticle();
        if (saved) {
            this.initializeNewArticle();
        }
    }

    public onCloseDialog() {
        this.dialog.close();
    }

    public checkInputFilled(event: Input$LiveChangeEvent) {
        const value = event.getParameter("value");
        if (value !== "") {
            event.getSource().setValueState("None");
        } else {
            event.getSource().setValueState("Error");
        }
    }

}